export const ABSOLUTE_NUMBERS_METRIC_OPTIONS: readonly number[] = [5000, 25000, 50000, 100000, 250000, 500000];

export const ABSOLUTE_NUMBERS_METRIC_DEFAULT_OPTION = 50000;

export const PERCENT_CHANGE_OPTIONS: readonly number[] = [0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.4, 0.5, 1, 2];
